import * as types from '../types/language';


export function setLanguage(data) {
  return dispatch => {
    return dispatch({
      type: types.SET_LANGUAGE,
      data: data,
    });
  }
}


// WEBPACK FOOTER //
// ./src/actions/languageActions.js